module.exports = __webpack_public_path__ + "static/media/finance.d11da437.png";